import React, {useContext} from 'react';

import api    from '../../../api';
import values from '../../../values';

import { useQuery             } from 'react-query';
import { locationNamespace    } from '../../../types/location.namespace';
import { CustomDropdownSearch } from '../../index';

import './index.sass';
import Context from "../../../context";
import utils from "../../../utils";
import Cookies from "js-cookie";

type Props = {
  isError         ?: boolean;
  errorText       ?: string;
  defaultItem      : locationNamespace.city.index | undefined;
  onSelectItem     : (province: locationNamespace.city.index) => void;
  selectedProvince?: locationNamespace.province.index;
}

const CityDropdown: React.FC<Props> = (props: Props): React.ReactElement => {

  const { userInfo } = useContext(Context.UserScreen);
  const userType = utils.stringHexConversion.reverse(Cookies.get(values.constants.USER.TYPE));

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const getCity = useQuery(
    [values.useQueryKeys.locationGetProvince, props.selectedProvince?._id],
    () => api.get.common.searchCity({limit: 50, province: props.selectedProvince?._id})
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  const cityFiltered4Company = getCity?.data?.result && getCity?.data.result.docs?.filter((item: any) =>
    userInfo?.companyInformation?.city?.includes(item?._id)
  );

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  const dropdoneItems = userType === 'COMPANY' ? cityFiltered4Company : getCity?.data?.result?.docs;
  return (
    <section id='location-dropdown-search-city'>
      <span>انتخاب شهر</span>
      <CustomDropdownSearch
        isSearch
        items={dropdoneItems ?? []}
        itemName={'name'} placeHolder={'انتخاب شهر'}
        defaultItem={props.defaultItem}
        onSelectItem={props.onSelectItem}
      />
      {props?.isError && (<p>{props?.errorText}</p>)}
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
}

export default CityDropdown;
